import type { Meeting } from './types'
import SFetch from '@app/utils/sfetch'

export * from './types'

export async function fetchMeetings(): Promise<Meeting[] | null> {
  const url = window.Silverfin.Routes.client_meetings_past_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  return await SFetch.json<Meeting[]>(url)
}
